import type { EventRule } from "../lib/project-tracking";

export const PIXEL_CONFIRM_LABEL = "Pixel nur nach Bestätigung durch den Server (nur Pilot)";

/** TASK-236: per-rule option; absent = off, so existing rules stay as they are. */
export function RulePixelConfirm({
  rule,
  onChange,
  error,
}: {
  rule: Pick<EventRule, "pixel_confirm" | "browser"> & Partial<Pick<EventRule, "event_type" | "meta_hq_only">>;
  onChange: (patch: Pick<EventRule, "pixel_confirm">) => void;
  /** Server message of a rejected save (`pixel_confirm_invalid`), shown at the option. */
  error?: string | null;
}) {
  const on = rule.pixel_confirm === true;
  // The server rejects the option without the browser pixel: block it here, too.
  const blocked = !rule.browser;
  return (
    <>
      <label
        className={`flex items-center gap-1 text-xs ${blocked ? "text-text-tertiary/50" : "text-text-secondary"}`}
        title={blocked ? "Zuerst „Auch im Browser als Pixel feuern“ anhaken" : undefined}
      >
        <input type="checkbox" checked={on} disabled={blocked} onChange={(e) => onChange({ pixel_confirm: e.target.checked })} />{" "}
        {PIXEL_CONFIRM_LABEL}
      </label>
      {on && error && <span className="w-full text-xs text-danger">{error}</span>}
      {on && rule.event_type === "HQLead" && rule.meta_hq_only !== true && (
        <span className="w-full text-xs text-danger">
          Ohne „An Meta nur HQ-Leads als Lead melden“ bleibt der Pixel stumm: der Server bestätigt den HQ-Lead nur als „Lead“.
        </span>
      )}
      {on && (
        <span className="w-full text-[10px] text-text-tertiary">
          Der Pixel feuert nur, wenn der Server für die Person einen Lead aus dem Mailtool/Webhook gemerkt hat. Diese
          Regel schickt kein Ereignis ins Tool, auch nicht beim Verlassen der Seite.
        </span>
      )}
    </>
  );
}
